import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FilterPagiTableComponent } from './filter-pagi-table/filter-pagi-table.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CrudComponent } from './crud/crud.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzColorPickerModule } from 'ng-zorro-antd/color-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { IframeGridComponent } from './iframe-grid/iframe-grid.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { BaseChartDirective } from 'ng2-charts';
import { ChartComponent } from './chart/chart.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { CustomDatePipe } from './pipes/custom-date.pipe';

@NgModule({
  declarations: [
    FilterPagiTableComponent,
    CrudComponent,
    IframeGridComponent,
    FormErrorComponent,
    ChartComponent,
    CustomDatePipe
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NzTableModule,
    NzCardModule,
    NzInputModule,
    NzButtonModule,
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzDropDownModule,
    FormsModule,
    ReactiveFormsModule,
    NzDrawerModule,
    NzFormModule,
    NzMessageModule,
    NzSelectModule,
    NzSwitchModule,
    NzImageModule,
    NzPageHeaderModule,
    NzSpaceModule,
    NzTagModule,
    NzDescriptionsModule,
    NzColorPickerModule,
    NzUploadModule,
    NzTabsModule,
    NzModalModule,
    NzBadgeModule,
    NzDatePickerModule,
    BaseChartDirective,
    NzPopconfirmModule
  ],
  exports: [
    TranslateModule,
    FilterPagiTableComponent,
    CrudComponent,
    IframeGridComponent,
    FormErrorComponent,
    ChartComponent,
    NzCardModule,
    NzInputModule,
    NzButtonModule,
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzDropDownModule,
    FormsModule,
    NzDrawerModule,
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzMessageModule,
    NzSelectModule,
    NzSwitchModule,
    NzImageModule,
    NzPageHeaderModule,
    NzSpaceModule,
    NzTagModule,
    NzDescriptionsModule,
    NzColorPickerModule,
    NzUploadModule,
    CommonModule,
    NzTabsModule,
    NzModalModule,
    NzBadgeModule,
    NzDatePickerModule,
    BaseChartDirective,
    NzPopconfirmModule,
    CustomDatePipe
  ],
  providers: [DatePipe, CustomDatePipe]
})
export class SharedModule {}
